// extracted by mini-css-extract-plugin
export var section = "media-module--section--23vwG";
export var inner = "media-module--inner--2M0XC";
export var jsAnimInit = "media-module--jsAnimInit--243Qo";
export var list = "media-module--list--3FMU7";
export var list_slogan = "media-module--list_slogan--3TgQC";
export var device = "media-module--device--1kbmX";
export var device_media = "media-module--device_media--26-o2";
export var video = "media-module--video--1Pbrk";